export default __webpack_public_path__ + "assets/images/default_user.d8e7a29121acf4955d39dd6feb08ab41.jpg";